module.exports = __webpack_public_path__ + "img/coupon_detail_3@2x.fd84aef9.svg";